<hlm-dialog-header>
  <h3 hlmDialogTitle>Créer un nouveau parcours</h3>
</hlm-dialog-header>

<div class="gap-lg p-md flex flex-col">
  <div class="paragraph-medium-medium text-content-secondary">
    <p>
      Vous souhaitez ajouter un nouveau parcours pour la cartographie
      <span class="paragraph-medium-semibold">{{ cartographie }}</span> pour le métier
      <span class="paragraph-medium-semibold">{{ referentiel }}</span> ?
    </p>
    <p>Pour ce faire, rien de plus simple : donnez-lui un nom et validez.</p>
  </div>
  <div hlmField>
    <label hlmFieldLabel for="input-nom" labelRequired>Nom du parcours</label>
    <input id="input-nom" [(ngModel)]="nom" hlmInput type="text" />
  </div>
</div>

<hlm-dialog-footer class="p-md flex w-full justify-between">
  <button brnDialogClose hlmBtn variant="secondary" type="button">Annuler</button>
  <button (click)="valider()" hlmBtn type="button">Valider la création</button>
</hlm-dialog-footer>
